// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc } from '../../routes/bids/components/PlanBasedBidsTable.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidContractProrationRevisionQueryVariables = Types.Exact<{
  bidContractRevisionId: Types.Scalars['ID']['input'];
}>;


export type BidContractProrationRevisionQuery = { __typename?: 'Query', bidContractRevision: { __typename?: 'BidContractRevision', id: string, bidContract: { __typename?: 'BidContract', id: string, type?: { __typename?: 'BidContractTypeDetail', code: Types.BidContractType } | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }, tradeLineItems: Array<{ __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, prorations: Array<{ __typename?: 'BidContractProration', id: string, costInCents: number, userEntered: boolean, lineItem: { __typename?: 'BidContractLineItem', id: string, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string } | { __typename?: 'ItemTemplateItem', id: string } | { __typename?: 'TakeoffLineItem', id: string } | { __typename?: 'TakeoffLineItemVersion', id: string } | null | undefined } }> }>, bidPackageVersion?: { __typename?: 'BidPackageVersion', id: string, relevantTakeoffLineItemVersions: Array<{ __typename?: 'TakeoffLineItemVersion', quantity?: number | null | undefined, id: string, name: string, identity: { __typename?: 'TakeoffLineItem', id: string }, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string, displayName: string, number: string, name: string } }, bidItem?: { __typename?: 'BidItem', id: string, parentMaterialVariant?: { __typename?: 'MaterialVariant', id: string, code: string } | null | undefined } | null | undefined, unitOfMeasure: { __typename?: 'UnitOfMeasure', id: string, shortName: string }, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined, parent: { __typename?: 'ReadyPlan', id: string, displayName: string } | { __typename?: 'PlanPackage', id: string, displayName: string } | { __typename?: 'DesignPackage', id: string, displayName: string } | { __typename?: 'ProductOffering', id: string, displayName: string }, readyPlan: { __typename?: 'ReadyPlan', id: string, name: string } | { __typename?: 'PlanPackage', id: string, name: string } | { __typename?: 'DesignPackage', id: string, name: string } | { __typename?: 'ProductOffering', id: string, name: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, type: { __typename?: 'GlobalOptionType', id: string, name: string } }>, laborLine?: { __typename?: 'TakeoffLineItem', id: string } | null | undefined, costEstimate: { __typename?: 'CostEstimate', costInCents: number }, drop?: { __typename?: 'Drop', id: string, code: string, name: string } | null | undefined }> } | null | undefined, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean } } };

export type BidContractProrationTradeLineItemFragment = { __typename?: 'BidContractTradeLineItem', id: string, totalCostInCents: number, bidItem?: { __typename?: 'BidItem', id: string } | null | undefined, productOffering: { __typename?: 'ProductOffering', id: string }, options: Array<{ __typename?: 'ReadyPlanOption', id: string }>, prorations: Array<{ __typename?: 'BidContractProration', id: string, costInCents: number, userEntered: boolean, lineItem: { __typename?: 'BidContractLineItem', id: string, itemTemplateItem?: { __typename?: 'ItemTemplateItemVersion', id: string } | { __typename?: 'ItemTemplateItem', id: string } | { __typename?: 'TakeoffLineItem', id: string } | { __typename?: 'TakeoffLineItemVersion', id: string } | null | undefined } }> };

export const BidContractProrationTradeLineItemFragmentDoc = gql`
    fragment BidContractProrationTradeLineItem on BidContractTradeLineItem {
  id
  totalCostInCents
  bidItem {
    id
  }
  productOffering {
    id
  }
  options {
    id
  }
  prorations {
    id
    costInCents
    userEntered
    lineItem {
      id
      itemTemplateItem {
        id
      }
    }
  }
}
    `;
export const BidContractProrationRevisionDocument = gql`
    query BidContractProrationRevision($bidContractRevisionId: ID!) {
  bidContractRevision(id: $bidContractRevisionId) {
    id
    bidContract {
      id
      type {
        code
      }
      tradePartner {
        id
        name
      }
    }
    tradeLineItems {
      ...BidContractProrationTradeLineItem
    }
    bidPackageVersion {
      relevantTakeoffLineItemVersions {
        ...PlanBasedBidsTable_TakeoffLineItemVersion
      }
      id
    }
    canEdit {
      allowed
    }
  }
}
    ${BidContractProrationTradeLineItemFragmentDoc}
${PlanBasedBidsTable_TakeoffLineItemVersionFragmentDoc}`;

/**
 * __useBidContractProrationRevisionQuery__
 *
 * To run a query within a React component, call `useBidContractProrationRevisionQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidContractProrationRevisionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidContractProrationRevisionQuery({
 *   variables: {
 *      bidContractRevisionId: // value for 'bidContractRevisionId'
 *   },
 * });
 */
export function useBidContractProrationRevisionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidContractProrationRevisionQuery, BidContractProrationRevisionQueryVariables> & ({ variables: BidContractProrationRevisionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidContractProrationRevisionQuery, BidContractProrationRevisionQueryVariables>(BidContractProrationRevisionDocument, options);
      }
export function useBidContractProrationRevisionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidContractProrationRevisionQuery, BidContractProrationRevisionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidContractProrationRevisionQuery, BidContractProrationRevisionQueryVariables>(BidContractProrationRevisionDocument, options);
        }
export function useBidContractProrationRevisionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidContractProrationRevisionQuery, BidContractProrationRevisionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidContractProrationRevisionQuery, BidContractProrationRevisionQueryVariables>(BidContractProrationRevisionDocument, options);
        }
export type BidContractProrationRevisionQueryHookResult = ReturnType<typeof useBidContractProrationRevisionQuery>;
export type BidContractProrationRevisionLazyQueryHookResult = ReturnType<typeof useBidContractProrationRevisionLazyQuery>;
export type BidContractProrationRevisionSuspenseQueryHookResult = ReturnType<typeof useBidContractProrationRevisionSuspenseQuery>;
export type BidContractProrationRevisionQueryResult = Apollo.QueryResult<BidContractProrationRevisionQuery, BidContractProrationRevisionQueryVariables>;